import { Component, OnInit } from '@angular/core';
import { VacancyService } from '../providers/vacancy.service';
import { Vacancy } from '../core/vacancy';
import { StorageService } from '../storage.service';
import { UsingMode } from '../core/review';
import { TramApiService } from '../tram-api.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ToasterService } from 'angular5-toaster/angular5-toaster';

@Component({
    selector: 'vacancy',
    templateUrl: './vacancy.component.html',
    styleUrls: ['./vacancy.component.scss']
})
export class VacancyComponent implements OnInit {
    UsingMode = UsingMode;

    mode: UsingMode = UsingMode.Anonymous;
    vacancies: Vacancy[];

    vacancyForm: FormGroup;
    deletingHandler = (vacancy: Vacancy) => { this.delete(vacancy); };

    constructor(private vacancyService: VacancyService,
        private storage: StorageService,
        private api: TramApiService,
        private toaster: ToasterService) {
        this.vacancyService.get()
            .subscribe(r => this.vacancies = r.data);
    }

    ngOnInit() {
        this.mode = UsingMode.Anonymous;

        if (this.storage.isSensitiveDataExist.value) {
            this.api
                .getCurrentUser()
                .then(user => {
                    this.mode = user && user.isModerator
                        ? UsingMode.God
                        : UsingMode.Anonymous;

                    if (this.mode === UsingMode.God) {
                        this.vacancyForm = new FormGroup({
                            'title': new FormControl(null, Validators.required),
                            'duties': new FormArray([
                                new FormControl(null, Validators.required),
                                new FormControl(null, Validators.required),
                                new FormControl(null, Validators.required)]),
                            'requirements': new FormArray([
                                new FormControl(null, Validators.required),
                                new FormControl(null, Validators.required),
                                new FormControl(null, Validators.required)])
                        });
                    }
                })
                .catch(error => { });
        }
    }

    addEmptyDutyControl() {
        (<FormArray>this.vacancyForm.controls['duties']).push(new FormControl(null, Validators.required));
    }
    removeDutyControl(index: number) {
        (<FormArray>this.vacancyForm.controls['duties']).removeAt(index);
    }

    addEmptyRequirementControl() {
        (<FormArray>this.vacancyForm.controls['requirements']).push(new FormControl(null, Validators.required));
    }
    removeRequirementControl(index: number) {
        (<FormArray>this.vacancyForm.controls['requirements']).removeAt(index);
    }

    onSubmit() {
        const model = this.vacancyForm.value;
        const serializedModel = JSON.stringify(model);

        const result = this.vacancyService.publish(serializedModel);
        result.subscribe(newVacancy => {
            this.vacancies.push(newVacancy);

            this.vacancyForm.reset();
            this.vacancies.push(model);

            this.toaster.pop('success', null, 'Позиция опубликована');
        }, error => {
            this.toaster.pop('error', null, error);
        });
    }

    private delete(vacancy: Vacancy) {
        const result = this.vacancyService.remove(vacancy.id);
        result.subscribe(isRemoved => {
            if (isRemoved) {
                const index = this.vacancies.findIndex(v => {
                    return v.id === vacancy.id;
                });

                if (index >= 0) {
                    this.vacancies.splice(index, 1);
                }

                this.toaster.pop('success', null, 'Позиция удалена');
            }
        }, error => {
            this.toaster.pop('error', null, error);
        });
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/vacancy.component.ts